import React from 'react'
import './DocumentViewer.sass'
import DocumentsViewerStore from './Store/DocumentsViewerStore'
import { Rnd } from 'react-rnd'
import { Portal } from 'react-portal'
import ImageViewer from './Components/ImageViewer'
import Animated from 'react-animated-transitions'
import 'animate.css'
import VideoPlayer from './Components/VideoPlayer'
import AudioPlayer from './Components/AudioPlayer'
import IframeViewer from './Components/IframeViewer'
import VideoListPlayer from './Components/VideoListPlayer'
import ProtectedVideo from './Components/ProtectedVideo'
import { useKey } from 'react-use'
import withStore from '../../../Components/Unstated/withStore'

const DocumentsViewer = ({
  documentsViewerStore: { state, closeDocument },
}) => {
  useKey('Escape', () => closeDocument())

  const { openDocument: doc } = state

  return doc ? (
    <Animated enter='fadeIn' exit='fadeOut' timeout={300}>
      <Portal node={doc.node}>
        <div className='documentsViewer'>
          <div className='dragWrapper' onClick={(e) => e.stopPropagation()}>
            <Rnd
              dragHandleClassName='topBar'
              default={{
                x: window.innerWidth * 0.2,
                y: window.innerHeight * 0.2,
                width: window.innerWidth * 0.6,
                height: window.innerHeight * 0.6,
              }}
              bounds={'.documentsViewer'}
            >
              <div className='container'>
                <div className='topBar'>
                  <p className='name'>{doc.name}</p>
                  <span className='close' onClick={() => closeDocument()} />
                </div>
                <div className='media'>
                  {doc.type.includes('image') ? (
                    <ImageViewer url={doc.url} name={doc.name} />
                  ) : doc.type.includes('protected-video') ? (
                    <ProtectedVideo
                      url={doc.url}
                      name={doc.name}
                      otp={doc.otp}
                      playbackInfo={doc.playbackInfo}
                    />
                  ) : doc.type.includes('video') ? (
                    <VideoPlayer url={doc.url} name={doc.name} />
                  ) : doc.type.includes('playlist') ? (
                    <VideoListPlayer url={doc.url} name={doc.name} />
                  ) : doc.type.includes('audio') ? (
                    <AudioPlayer url={doc.url} name={doc.name} />
                  ) : (
                    <IframeViewer
                      url={doc.url}
                      name={doc.name}
                      type={doc.type}
                    />
                  )}
                </div>
              </div>
            </Rnd>
          </div>
        </div>
      </Portal>
    </Animated>
  ) : (
    <div />
  )
}

export default withStore([DocumentsViewerStore])(DocumentsViewer)
